import { queries as aboutQueries } from "domains/pros/containers/PROfileAbout/queries";
import { queries as certificationsQueries } from "domains/pros/containers/PROfileCertifications/queries";
import { queries as experienceQueries } from "domains/pros/containers/PROfileExperience/queries";
import { queries as gigHistorySummaryQueries } from "domains/pros/containers/PROfileGigHistorySummary/queries";
import { queries as headerQueries } from "domains/pros/containers/PROfileHeader/queries";
import { queries as reviewsQueries } from "domains/pros/containers/PROfileReviews/queries";
import { queries as skillsQueries } from "domains/pros/containers/PROfileSkills/queries";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { proId: number; isAdmin: boolean };

export const queries = ({ proId, isAdmin }: QueriesInput): Array<WarmableQuery> => {
  const input = { id: proId, isAdmin };
  return [
    ...headerQueries(input),
    ...aboutQueries(input),
    ...reviewsQueries(input),
    ...gigHistorySummaryQueries(input),
    ...experienceQueries(input),
    ...certificationsQueries(input),
    ...skillsQueries(input),
  ];
};
